import React from "react";
import { Row, Col, Select, Table, message, Layout, Icon } from "antd";
import MiCompAPI from "../../util/api";
import moment from "moment";
import TableWrapper from "../elements/TableWrapper";
import img from "./../../assets/img/At the office-pana 1.png";

const { Content } = Layout;
const { Option } = Select;
class CarrierBook extends React.Component {
  adj_trans = [
    {
      title: "Description Type",
      dataIndex: "trans_type_desc",
      key: "1",
      sorter: (a, b) => a.trans_type_desc.localeCompare(b.trans_type_desc),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Transaction Note",
      dataIndex: "trans_desc",
      key: "2",
    },
    {
      title: "Transaction Date",
      dataIndex: "transaction_date",
      key: "3",
      render: (text, record) =>
        record["transaction_date"] !== null && record["transaction_date"] !== ""
          ? moment(record["transaction_date"]).format("MM/DD/YYYY")
          : "",
      sorter: (a, b) =>
        new Date(a.transaction_date) - new Date(b.transaction_date),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Transaction Amount",
      dataIndex: "trans_amt",
      key: "4",
      render: (text, record) =>
        record["trans_type_code"] === "D" ? <> (${text}) </> : <> ${text} </>,
    },
    {
      title: "Adjusted Invoice No",
      dataIndex: "inv_no",
      key: "5",
      sorter: (a, b) => a.inv_no.localeCompare(b.inv_no),
      sortDirections: ["descend", "ascend"],
    },
  ];
  payhistory = [
    {
      title: "Entity Type",
      dataIndex: "entity_type",
      key: "2",
      sorter: (a, b) => a.entity_type.localeCompare(b.entity_type),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Entity Name",
      dataIndex: "entity_name",
      key: "2",
      sorter: (a, b) => a.entity_name.localeCompare(b.entity_name),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Check Number",
      dataIndex: "chq_no",
      key: "2",
      sorter: (a, b) => a.chq_no.localeCompare(b.chq_no),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Year",
      dataIndex: "yr",
      key: "3",
    },
    {
      title: "Month",
      dataIndex: "mnth",
      key: "4",
    },
    {
      title: "Commission amount",
      dataIndex: "chq_amt",
      key: "5",
      render: (text) => <>${text}</>,
    },
    {
      title: "Invoice Date",
      dataIndex: "date_of_gen",
      key: "8",
      render: (text, record) =>
        record["date_of_gen"] !== null && record["date_of_gen"] !== ""
          ? moment(record["date_of_gen"]).format("MM/DD/YYYY")
          : "",
      sorter: (a, b) => new Date(a.date_of_gen) - new Date(b.date_of_gen),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Payment Date",
      dataIndex: "payment_date",
      key: "9",
      render: (text, record) =>
        record["payment_date"] !== null && record["payment_date"] !== ""
          ? moment(record["payment_date"]).format("MM/DD/YYYY")
          : "",
      sorter: (a, b) => new Date(a.payment_date) - new Date(b.payment_date),
      sortDirections: ["descend", "ascend"],
    },
  ];
  payinvhistory = [
    {
      title: "Incentive Type",
      dataIndex: "invoice_type",
      key: "1",
      sorter: (a, b) => a.invoice_type.localeCompare(b.invoice_type),
      sortDirections: ["descend", "ascend"],
    },

    {
      title: "Total Amount",
      dataIndex: "base_amt",
      key: "3",
      render: (text) => <>${text}</>,
      sorter: (a, b) => a.base_amt.localeCompare(b.base_amt),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Tax Amount",
      dataIndex: "tax_amt",
      key: "4",
      render: (text) => <>${text}</>,
    },
    {
      title: "Net Amount",
      dataIndex: "net_amt",
      key: "5",
      render: (text) => <>${text}</>,
    },
  ];
  invhistory = [
    {
      title: "Invoice No",
      dataIndex: "invoice_no",
      key: "1",
    },
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      key: "2",
    },
    {
      title: "Adjustment Type",
      dataIndex: "adjustment_type",
      key: "3",
    },
    {
      title: "Adjusted Amount",
      dataIndex: "adjusted_amount",
      key: "4",
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "5",
    },
  ];
  months = [
    {
      title: "Label",
      dataIndex: "Label",
      key: "0",
      align: "center",
      render: (text) =>
        text ? (
          <>
            {" "}
            <h6
              title=" Amount"
              style={{ textAlign: "initial" }}
              className="mi_ancor"
            >
              {text}
            </h6>
          </>
        ) : (
          ""
        ),
    },
    {
      title: "Jan",
      dataIndex: "Jan",
      key: "1",
      align: "center",
      render: (text) =>
        text ? (
          <>
            {" "}
            <h6
              title="Actual Amount"
              className="mi_ancor"
              onClick={() => {
                this.getPaymentHis(1);
              }}
            >
              {text}
            </h6>
          </>
        ) : (
          ""
        ),
    },
    {
      title: "Feb",
      dataIndex: "Feb",
      key: "2",
      align: "center",
      render: (text) =>
        text ? (
          <>
            {" "}
            <h6
              title="Actual Amount"
              className="mi_ancor"
              onClick={() => {
                this.getPaymentHis(2);
              }}
            >
              {text}
            </h6>
          </>
        ) : (
          ""
        ),
    },
    {
      title: "Mar",
      dataIndex: "Mar",
      key: "3",
      align: "center",
      render: (text) =>
        text ? (
          <>
            {" "}
            <h6
              title="Actual Amount"
              className="mi_ancor"
              onClick={() => {
                this.getPaymentHis(3);
              }}
            >
              {text}
            </h6>
          </>
        ) : (
          ""
        ),
    },
    {
      title: "Apr",
      dataIndex: "Apr",
      key: "4",
      align: "center",
      render: (text) =>
        text ? (
          <>
            {" "}
            <h6
              title="Actual Amount"
              className="mi_ancor"
              onClick={() => {
                this.getPaymentHis(4);
              }}
            >
              {text}
            </h6>
          </>
        ) : (
          ""
        ),
    },
    {
      title: "May",
      dataIndex: "May",
      key: "5",
      align: "center",
      render: (text) =>
        text ? (
          <>
            {" "}
            <h6
              title="Actual Amount"
              className="mi_ancor"
              onClick={() => {
                this.getPaymentHis(5);
              }}
            >
              {text}
            </h6>
          </>
        ) : (
          ""
        ),
    },
    {
      title: "Jun",
      dataIndex: "Jun",
      key: "6",
      align: "center",
      render: (text) =>
        text ? (
          <>
            {" "}
            <h6
              title="Actual Amount"
              className="mi_ancor"
              onClick={() => {
                this.getPaymentHis(6);
              }}
            >
              {text}
            </h6>
          </>
        ) : (
          ""
        ),
    },
    {
      title: "Jul",
      dataIndex: "Jul",
      key: "7",
      align: "center",
      render: (text) =>
        text ? (
          <>
            {" "}
            <h6
              title="Actual Amount"
              className="mi_ancor"
              onClick={() => {
                this.getPaymentHis(7);
              }}
            >
              {text}
            </h6>
          </>
        ) : (
          ""
        ),
    },
    {
      title: "Aug",
      dataIndex: "Aug",
      key: "8",
      align: "center",
      render: (text) =>
        text ? (
          <>
            {" "}
            <h6
              title="Actual Amount"
              className="mi_ancor"
              onClick={() => {
                this.getPaymentHis(8);
              }}
            >
              {text}
            </h6>
          </>
        ) : (
          ""
        ),
    },
    {
      title: "Sep",
      dataIndex: "Sep",
      key: "9",
      align: "center",
      render: (text) =>
        text ? (
          <>
            {" "}
            <h6
              title="Actual Amount"
              className="mi_ancor"
              onClick={() => {
                this.getPaymentHis(9);
              }}
            >
              {text}
            </h6>
          </>
        ) : (
          ""
        ),
    },
    {
      title: "Oct",
      dataIndex: "Oct",
      key: "10",
      align: "center",
      render: (text) =>
        text ? (
          <>
            {" "}
            <h6
              title="Actual Amount"
              className="mi_ancor"
              onClick={() => {
                this.getPaymentHis(10);
              }}
            >
              {text}
            </h6>
          </>
        ) : (
          ""
        ),
    },
    {
      title: "Nov",
      dataIndex: "Nov",
      key: "11",
      align: "center",
      render: (text) =>
        text ? (
          <>
            {" "}
            <h6
              title="Actual Amount"
              className="mi_ancor"
              onClick={() => {
                this.getPaymentHis(11);
              }}
            >
              {text}
            </h6>
          </>
        ) : (
          ""
        ),
    },
    {
      title: "Dec",
      dataIndex: "Dec",
      key: "12",
      align: "center",
      render: (text) =>
        text ? (
          <>
            {" "}
            <h6
              title="Actual Amount"
              className="mi_ancor"
              onClick={() => {
                this.getPaymentHis(12);
              }}
            >
              {text}
            </h6>
          </>
        ) : (
          ""
        ),
    },
  ];
  constructor(props) {
    super(props);
    this.state = {
      years: [],
      loas: [],
      loa: "0",
      entity_types: [],
      entity_type: "all",
      record: [],
      isSumShow: false,
      _years: [new Date().getFullYear()],
      commission: [],
      pay_his: false,
      pay_his_data: [],
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentDidMount = () => {
    this.getBoBSummary();
    this.getClientMasters();
  };

  UserDefaultHandler = (record) => {
    this.setState({
      record,
      isSumShow: !this.state.isSumShow,
    });
  };
  getPaymentHis = (record) => {
    this.setState({
      pay_his: true,
    });

    var data = {
      loa: this.state.loa,
      mnth: record,
      entity_type: this.state.entity_type,
      years: this.state._years,
    };
    this.setState({ isLoading: true });
    this.api.invoke(
      "GetPaymeny_HisofClient",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              pay_his_data: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      data
    );
  };
  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            years: data.years,
            loas: data.lobs,
            entity_types: data.entity,
          });
        }
      },
      ["YR", "LOB", "ENTITY"]
    );
  }
  getBoBSummary() {
    this.setState({ isLoading: true });
    var data = {
      loa: this.state.loa,
      entity_type: this.state.entity_type,
      years: this.state._years,
    };
    this.api.invoke(
      "GetBobSummaryforClient",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              commission: data.data,
              pay_his: false,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      data
    );
  }
  search = (type, e) => {
    if (type === "year") {
      this.setState({
        _years: [e],
      });
    }
    if (type === "entity") {
      this.setState({
        entity_type: e,
      });
    }
    if (type === "loa") {
      this.setState({
        loa: e,
      });
    }
    setTimeout(() => {
      this.getBoBSummary();
    }, 100);
  };
  render() {
    return (
      <Content>
        <div className="mi_box" style={{ marginTop: "20px" }}>
          <Row span={24}>
            <Col span={18}>
              <h4 className="mi_box_h4">Our Book</h4>
            </Col>
            <Col span={6}>
              <img
                alt="example"
                style={{ height: "150px", marginTop: "-50px" }}
                src={img}
              />
            </Col>
          </Row>
        </div>

        <Row span={24}>
          <Col span={8}>
            <fieldset className="mi_input_pop">
              <legend className="legend-font">LOA </legend>
              <Select
                suffixIcon={
                  <Icon
                    style={{ transform: "rotate(90deg)" }}
                    type="double-right"
                  />
                }
                className="mi_input"
                showSearch={true}
                placeholder="Please Select"
                optionFilterProp="children"
                onChange={this.search.bind(this, "loa")}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                defaultValue={this.state.loa ? this.state.loa : undefined}
              >
                <Option value="0" key="0">
                  All
                </Option>
                {this.state.loas.map((tag) => (
                  <Option value={tag.name} key={tag.name}>
                    {tag.name}
                  </Option>
                ))}
              </Select>
            </fieldset>
          </Col>
          <Col span={8}>
            <fieldset className="mi_input_pop">
              <legend className="legend-font">Entity type</legend>
              <Select
                suffixIcon={
                  <Icon
                    style={{ transform: "rotate(90deg)" }}
                    type="double-right"
                  />
                }
                className="mi_input"
                showSearch={true}
                placeholder="Please Select"
                optionFilterProp="children"
                onChange={this.search.bind(this, "entity")}
                defaultValue={
                  this.state.entity_type ? this.state.entity_type : undefined
                }
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option value="All" key="0">
                  All
                </Option>
                {this.state.entity_types.map((tag) => (
                  <Option value={tag.name} key={tag.id}>
                    {tag.name}
                  </Option>
                ))}
              </Select>
            </fieldset>
          </Col>

          <Col span={8}>
            <fieldset className="mi_input_pop">
              <legend className="legend-font">Year</legend>
              <Select
                suffixIcon={
                  <Icon
                    style={{ transform: "rotate(90deg)" }}
                    type="double-right"
                  />
                }
                className="mi_input"
                showSearch={true}
                onChange={this.search.bind(this, "year")}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder="Please Select"
                defaultValue={this.state._years ? this.state._years : undefined}
              >
                {this.state.years
                  ? this.state.years.map((tag) => (
                      <Option value={tag.id} key={tag.id}>
                        {tag.name}
                      </Option>
                    ))
                  : ""}
              </Select>
            </fieldset>
          </Col>
        </Row>
        <Row span={24}>
          <Col span={24} style={{ marginTop: "20px" }}>
            <Table
              rowKey="1"
              title={() => <p className="mi_table_title">Commission</p>}
              dataSource={this.state.commission}
              columns={this.months}
              pagination={false}
              bordered={false}
            ></Table>
          </Col>
        </Row>
        <Row span={24}>
          <Col span={24} style={{ marginTop: "20px" }}>
            {this.state.pay_his ? (
              <>
                {this.state.pay_his_data.map((item) => {
                  return (
                    <>
                      <Row span={24}>
                        <Col style={{ marginTop: "5px", marginLeft: "10px" }}>
                          <p className="mi_table_title">
                            {"Year " + item.year}{" "}
                          </p>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={24} style={{ marginTop: "5px" }}>
                          <TableWrapper
                            rowKey="year"
                            data={item.bOBMonthlies}
                            columns={this.payhistory}
                            expandedRowRender={(record) => (
                              <>
                                <TableWrapper
                                  rowKey="inv_no"
                                  data={record.clientvisesummries}
                                  columns={this.payinvhistory}
                                ></TableWrapper>
                                {/* <TableWrapper rowKey="inv_no" data={record.inv_Adj_Trans_Models} title="Invoice Adjustment" columns={this.adj_trans}  ></TableWrapper> */}
                              </>
                            )}
                          />
                        </Col>
                      </Row>
                    </>
                  );
                })}
              </>
            ) : (
              ""
            )}
          </Col>
        </Row>
      </Content>
    );
  }
}
export default CarrierBook;
